export const ROLES = {
    User: "0001", //사용자
    Volunteer: "0002", //본사
    Distributor: "0003", //총판
    BranchManager: "0004", //지사장
    Agency: "0005", //대리점
    Admin: "0009", //관리자
};
